import { observeScrollAnimation } from "common/utils/ui/visibility";
import "./benefits.scss";

const $getBenefitCards = () => document.querySelectorAll(".benefits-card");

export default function initBenefits() {
  const $cards = $getBenefitCards();
  observeScrollAnimation($cards);
}
